import { Event, SendEventPayload } from 'types/events.types';

export const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const SEND_EVENT_REQUEST = 'SEND_EVENT_REQUEST';
export const SEND_EVENT_SUCCESS = 'SEND_EVENT_SUCCESS';
export const SEND_EVENT_FAILURE = 'SEND_EVENT_FAILURE';

export interface EventsState {
  events: Event[];
  loading: boolean;
  error: string | null;
  sendEventLoading: boolean;
  sendEventError: string | null;
}

export interface GetEventsRequestAction {
  type: typeof GET_EVENTS_REQUEST;
  [key: string]: any;
}

export interface GetEventsSuccessAction {
  type: typeof GET_EVENTS_SUCCESS;
  payload: Event[];
  [key: string]: any;
}

export interface GetEventsFailureAction {
  type: typeof GET_EVENTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface SendEventRequestAction {
  type: typeof SEND_EVENT_REQUEST;
  payload: SendEventPayload;
  [key: string]: any;
}

export interface SendEventSuccessAction {
  type: typeof SEND_EVENT_SUCCESS;
  [key: string]: any;
}

export interface SendEventFailureAction {
  type: typeof SEND_EVENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export type EventsActionTypes =
  | GetEventsRequestAction
  | GetEventsSuccessAction
  | GetEventsFailureAction
  | SendEventRequestAction
  | SendEventSuccessAction
  | SendEventFailureAction;
